import { ItemList } from '../orm'

class CustomerPhoneBookNumberList extends ItemList {
    getEntityKey() {
        return "customer_phone_book_number"
    }
}

export const customerPhoneBookNumberList = new CustomerPhoneBookNumberList("customer_phone_book_number__default")
